<template>
    <div>
      <label :for="elementId">{{ name }}</label>
          <b-form-group :id="elementId">
            <b-form-checkbox-group v-model="values" :options="items" stacked/>
            <div class="otherBox" v-if="otherField">
              <b-form-checkbox v-model="otherValue" value="other" @change="otherSwitched" inline>egyéb:</b-form-checkbox>
              <b-form-input v-model="otherText" :disabled="!otherValue.length > 0" @input="otherTextChanged" class="other-checkbox-text"></b-form-input>
            </div>
          </b-form-group>
    </div>
</template>

<script>

export default {
  name: 'check-boxes',
  props: ['items', 'name', 'otherField', 'elementId', 'property'],
  computed: {
      values: {
        get() {
          this.otherText = this.$store.state.form[this.property].filter(value => !this.itemValues.includes(value))[0] || ''
          if (this.otherText != '')
            this.otherValue = 'other'
          return this.$store.state.form[this.property]
        },
        set(values) {
          this.$store.commit('setFormProperty', { property: this.property, value: values })
        }
     },
     itemValues() {
        return this.items.map(item => item.value)
     }
  },
  data() {
    return {
      otherText: '',
      otherValue: [],
    }
  },
  methods: {
    otherSwitched(value) {
      const directStoredFormElement = this.$store.state.form[this.property]      
      if (value == 'other')
        this.values = directStoredFormElement.concat([this.otherText])
      if (!value) {
        this.otherText = ''
        this.values = directStoredFormElement.filter(element => this.itemValues.includes(element))
      }
    },
    otherTextChanged(other) {
      const directStoredFormElement = this.$store.state.form[this.property]      
      const otherIndex = directStoredFormElement.findIndex(element => !this.itemValues.includes(element))      
      if (otherIndex == -1)
        this.values = directStoredFormElement.concat([other])
      else {
        directStoredFormElement[otherIndex] = other
        this.values = directStoredFormElement
      }
    }
  }
}
</script>

<style scoped>

label, legend {
  font-weight: bold;
}

.otherBox {
  display: inline-flex;
  align-items: center;
}

</style>

